'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.default = function () {
    var inputAnimation = new InputAnimation();
    inputAnimation.init();
    window.linksoft.inputAnimation = inputAnimation;
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fillClassName = 'input--filled';
var inputClass = '.form__input input:not([type=hidden]):not([type=checkbox])';

var InputAnimation = function () {
    function InputAnimation() {
        (0, _classCallCheck3.default)(this, InputAnimation);
    }

    (0, _createClass3.default)(InputAnimation, [{
        key: 'toggleInputClass',
        value: function toggleInputClass($elm) {
            //for better display after first init
            $elm.addClass('input--init');

            if ($elm.val().trim() !== '') {
                $elm.addClass(fillClassName);
            } else {
                $elm.removeClass(fillClassName);
            }
        }
    }, {
        key: 'initEvents',
        value: function initEvents() {
            var self = this;
            (0, _jquery2.default)(document).find(inputClass).on('blur', function () {
                self.toggleInputClass((0, _jquery2.default)(this));
            });
        }
    }, {
        key: 'applyToInputs',
        value: function applyToInputs() {
            var self = this;
            (0, _jquery2.default)(inputClass).each(function () {
                var $this = (0, _jquery2.default)(this);
                var placeholder = $this.attr("placeholder");
                var $label = $this.next().not('button'); // input autor

                if ($label.length > 0 && placeholder) {
                    $label.text(placeholder);
                    $this.attr("placeholder", "");
                }

                // situation line in forgot password
                if ($this.hasClass(fillClassName)) {
                    return;
                }
                self.toggleInputClass($this);
            });
        }
    }, {
        key: 'init',
        value: function init() {
            var self = this;
            this.applyToInputs();

            // this one prevent chrome autofill inputs
            (0, _jquery2.default)(inputClass).on('change', function () {
                self.toggleInputClass((0, _jquery2.default)(this));
            });
        }
    }]);
    return InputAnimation;
}();

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/inputAnimation.js
// module id = 1071
// module chunks = 0